import React from 'react'
import { Message } from 'semantic-ui-react'
import { connect } from 'react-redux'

const NewVersion = ({ isNewVersion }) => (
    isNewVersion ? <Message positive floating>
        <Message.Header>Una nuova versione è stata scaricata</Message.Header>
        <p><a href={window.location.href}>Clicca qui</a> per ricaricare la pagina.</p>
    </Message> :
    null
)


const mapStateToProps = (state) => ({
    isNewVersion: state.newVersion
})

export default connect(
    mapStateToProps
)(NewVersion)


// WEBPACK FOOTER //
// ./src/components/NewVersion.js